import * as types from './types';
import actions from './actions';
import {
  extend,
} from 'lodash';

const state = {
  //领书申请列表
  bookCollectionStatementList: {
    state: '',
    list: [],
    total: 0,
  },
  //领书申请教材详情列表
  bookCollectionDetailStatementList: {
    state: '',
    list:[]
  },
};

const getters = {
  //领书申请列表
  getBookCollectionStatementList: (state) =>state.bookCollectionStatementList,
  //领书申请教材详情列表
  getBookCollectionDetailStatementList: (state) =>state.bookCollectionDetailStatementList,
};

const mutations = {
  //领书申请列表
  [types.ACTION_BOOK_COLLECTION_STATEMENT_LIST]({bookCollectionStatementList}, result){
    extend(bookCollectionStatementList, result)
  },
  //领书申请教材详情列表
  [types.ACTION_BOOK_COLLECTION_DETAIL_STATEMENT_LIST](state, result){
    state.bookCollectionDetailStatementList = extend({},result.data);
  },
};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/bookCollection/index.js